import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Customer'

  }
];

@Component({
  selector: 'page-customer',
  templateUrl: './customer.html',
  styleUrls: ['./customer.scss']
})

export class PageCustomer implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  ctrl: FormControl;
  filtered: any;
  sysPathPrint: String = environment.sysPath + "/api/customer-list-print.php";
  sysPathExport: String = environment.sysPath + "/api/customer-list-export.php";
  rows = [];
  temp = [];

  customers = [];
  key: any;
  fetchCustomer = [];
  loadingIndicator: boolean = true;

  //diaglog
  dialogRef: MdDialogRef<CustomerDisableDialog>;
  selectedOption: string;

  constructor(private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {

    this.getDataStart();
    this.getCustomer();

    this._sharedService.emitChange(this.pageTitle);
  }
  getDataStart() {
    this.httpservice.fetchget('getJSON_customer.php?', data => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
    })
  }
  getCustomer() {
    this.httpservice.fetchget('getJSON_customer_name.php?', data => {
      this.customers = data;
    });
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        console.log('------val------', this.key);
        return val ? this.customers.filter((s) => new RegExp(val, 'gi').test(s.tc_company_shortname)) : this.customers;
      });
  }

  export() {
    this.httpservice.openExport('customer-list-export.php');
  }
  print() {
    this.httpservice.openPrint('customer-list-print.php');
  }

  disableCustomer(tc_id: string) {
    this.httpservice.fetchget('disableCustomer.php?tc_id=' + tc_id, data => {
      this.getDataStart();
    })
  }

  edit(tc_id: string) {
    this.router.navigateByUrl('default-layout/customer-form-edit/' + tc_id);
  }

  search() {

    this.httpservice.fetchget('getJSON_customer.php?key=' + this.key, data => {
      this.rows = data;
    });
  }

  ngOnInit() { }


  openDialog(tc_id: string) {

    let dialogRef = this.dialog.open(CustomerDisableDialog);
    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {
        this.disableCustomer(tc_id);
        console.log('---result---', result);
        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }

  updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.tc_company_shortname.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
}
//dialog
@Component({
  selector: 'customer-dialog',
  templateUrl: 'customer-dialog.html',
})
export class CustomerDisableDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<CustomerDisableDialog>) { }
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/customer/customer.ts